import { render } from "./orderUnPay.vue?vue&type=template&id=5ccca765"
import script from "./orderUnPay.vue?vue&type=script&lang=js"
export * from "./orderUnPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__